export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'この画面では設定したETC利用サイトの情報から高速料金が取得できます。<br>尚、金額はETCを利用した際の価格になります。大口割引は適用されていませんのでその旨ご承知ください。<br><br>使用にあたってのガイドが必要な場合は[次へ]を押してください。<br>すぐに始める場合は[操作ガイド終了]を押してください。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ]
})
